// extracted by mini-css-extract-plugin
export default {"wrap":"Label_wrap__JAnZC","label":"Label_label__5+XjI","value":"Label_value__mhFkn"};